module.exports = "<span ng-bind=\"count || 'Add'\"></span> {{name}}\n"


//////////////////
// WEBPACK FOOTER
// ./project/directives/lw-counter/lw-counter.html
// module id = 839
// module chunks = 3